<template>
  <div>
    <div class="row no-gutters mt-10 pl-container-align z-5 pr-sm-0 justify-content-sm-end justify-content-center">
      <div class="col-lg-10 col-14 text-sm-right">
        <div class="venue-carousel-filters mb-3">
          <button v-for="(category, index) in categories" :key="index" type="button" @click="selectCategory(category)" :class="{'active': selectedCategory.id == category.id}">{{category.title}}</button>
        </div>
      </div>
    </div>

    <div class="row no-gutters mb-10 pl-container-align z-5 pr-sm-0">
      <div class="col-lg-6 text-justify mb-lg-0 mb-6 mx-sm-0 mx-4">
        <slot name="text" :selectedCategory="selectedCategory"></slot>
      </div>

      <div class="col-lg-10 ml-sm-0 ml-8">
        <div class="venue-carousel">
          <slick ref="slick" :options="options" @afterChange="handleAfterChange" @init="handleOnInit">
            <slot name="slides"></slot>
          </slick>

          <div class="venue-carousel-pagination">
            <p class="page-current"><span v-if="currentSlide<10">0</span>{{currentSlide}}</p>
            <p class="page-length"><span v-if="slidesLength<10">0</span>{{slidesLength}}</p>
          </div>

          <div class="venue-carousel-nav">
            <button class="slick-prev"><i class="icon-arrow-medium-left icon-sm"></i></button>
            <button class="slick-next"><i class="icon-arrow-medium-right icon-sm"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Slick from 'vue-slick'

  export default {
    components: {
      Slick
    },
    props: {
      categories: {
        type: Array,
        required: true,
        default: null
      }
    },
    data() {
      return {
        slidesLength: null,
        selectedCategory: this.categories[0],
        currentSlide: 1,
        options: {
          rows: 0,
          slidesToShow: 1.7,
          infinite: false,
          // autoplay: true,
          autoplaySpeed: 3000,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: true,
          prevArrow: '.slick-prev',
          nextArrow: '.slick-next',
        }
      }
    },
    methods: {
      selectCategory(category) {
        this.selectedCategory = category
        this.$refs.slick.unfilter()
        this.$refs.slick.filter('.category-' + this.selectedCategory.id)
        this.$refs.slick.goTo(0, true)
        this.slidesLength = this.$refs.slick.$el.getElementsByClassName("slick-slide").length
      },
      handleAfterChange(event, slick, currentSlide) {
        this.currentSlide = currentSlide + 1
      },
      handleOnInit(event, slick) {
        const component = this
        setTimeout(function () {
          component.$refs.slick.filter('.category-' + component.selectedCategory.id)
          component.slidesLength = component.$refs.slick.$el.getElementsByClassName("slick-slide").length
        }, 0)
      }
    },
  }
</script>

<style lang="scss">
  .venue-carousel-filters {
    display: flex;
    overflow: hidden;

    button {
      font-size: 0.625rem;
      letter-spacing: 0.3rem;
      margin-right: 45px;
      position: relative;
      color: #a5a4a4;

      &.active,
      &:hover {
        color: #4a4a4a;
      }

      &::after {
        content: "";
        display: block;
        height: 10px;
        width: 1px;
        background: #a5a4a4;
        position: absolute;
        top: 50%;
        right: -23px;
        transform: translateY(-50%);
      }

      &:last-child {
        &::after {
          height: 1px;
          width: 1000px;
          transform: unset;
          right: unset;
          left: calc(100% + 25px);
        }
      }
    }
  }

  .venue-carousel {
    position: relative;

    .slick-slide {
      opacity: 0.3;
      transition: opacity 250ms ease-out;

      &.slick-current {
        opacity: 1;
      }
    }

    .venue-carousel-pagination {
      text-align: right;
      position: absolute;
      bottom: 0;
      left: 0;
      transform: translateX(-150%);

      .page-current {
        color: #767676;
        font-size: 1.5rem;
        line-height: 1;
        margin: 0;
        position: relative;
        font-weight: 300;

        &::after {
          content: "";
          height: 1px;
          width: 35px;
          position: absolute;
          top: 50%;
          left: 100%;
          background: $primary;
        }
      }

      .page-length {
        color: #969696;
        font-size: .875rem;
        font-weight: 300;
        margin-bottom: 0;
      }
    }

    .venue-carousel-nav {
      position: absolute;
      bottom: 10px;
      right: 33.5%;

      .slick-prev,
      .slick-next {
        background: rgba(76, 180, 174, 0.6);
        color: #fff;
        padding: 10px 10px;
        display: inline-flex;
        align-items: center;
      }
    }
  }

  // SM
  @media only screen and (max-width: 767px) {
    .venue-carousel-filters {
      button {
        font-size: 0.55rem;
        margin-right: 30px;

        &::after {
          right: -12px;
        }
      }
    }
  }

  // XS
  @media only screen and (max-width: 575px) {
    .venue-carousel-filters {
      flex-flow: wrap;
      justify-content: center;

      button {
        margin: 0px 10px;
        font-size: 1.25rem;

        &:last-child::after {
          content: none;
        }
      }
    }
  }
</style>